export const FETCH_LOCATION_DETAIL = 'FETCH_LOCATION_DETAIL';
export const FETCH_LOCATIONS = 'FETCH_LOCATIONS';
export const FETCH_SPECIALTIES = 'FETCH_SERVICES';
export const FETCH_SPECIALTIES_FAILED = 'FETCH_SERVICES_FAILED';
export const FETCH_SPECIALTIES_DONE = 'FETCH_SERVICES_DONE';

export const SEARCH_QUERY_UPDATED = 'SEARCH_QUERY_UPDATED';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const CLEAR_SEARCH_TEXT = 'CLEAR_SEARCH_TEXT';

export const SEARCH_STARTED = 'SEARCH_STARTED';
export const SEARCH_FAILED = 'SEARCH_FAILED';
// Submitted location can't be resolved (no geocoder match or state-only result);
// drives the inline "invalid location" message (CMS #22751).
export const LOCATION_INPUT_INVALID = 'LOCATION_INPUT_INVALID';

export const GEOCODE_STARTED = 'GEOCODE_STARTED';
export const GEOCODE_FAILED = 'GEOCODE_FAILED';
export const GEOCODE_COMPLETE = 'GEOCODE_COMPLETE';
export const GEOCODE_CLEAR_ERROR = 'GEOCODE_CLEAR_ERROR';

export const GEOLOCATE_USER = 'GEOLOCATE_USER';

export const MAP_MOVED = 'MAP_MOVED';

export const MOBILE_MAP_PIN_SELECTED = 'MOBILE_MAP_PIN_SELECTED';
